import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

/*
  ResetPasswordModal
  Props:
    - open: boolean (controls visibility)
    - onClose: function () => void
    - onSave: function (newPassword: string) => void (optional; if not provided just logs)
    - userId: number|string
    - login: string
*/

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 1,
};

export default function ResetPasswordModal({ open, onClose, onSave, userId, login }) {
  const { t } = useTranslation();
  const [password, setPassword] = React.useState('');

  React.useEffect(() => {
    if (open) {
      setPassword('');
    }
  }, [open]);

  const handleSave = () => {
    if (onSave) {
      onSave(password);
    } else {
      // Placeholder: will be replaced later with actual request
      // Keeping console.log as a stub per issue description
      // eslint-disable-next-line no-console
      console.log('Reset password for', { userId, login, newPassword: password });
    }
    if (onClose) onClose();
  };

  return (
    <Modal
      open={!!open}
      onClose={onClose}
      aria-labelledby="reset-password-title"
      aria-describedby="reset-password-description"
    >
      <Box sx={style}>
        <Typography id="reset-password-title" variant="h6" component="h2" gutterBottom>
          {t('reset_password')}
        </Typography>
        <Typography id="reset-password-description" variant="body2" color="text.secondary" gutterBottom>
          {t('reset_password_user', { login, id: userId })}
        </Typography>
        <TextField
          fullWidth
          type="password"
          label={t('new_password')}
          variant="standard"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ mt: 2, mb: 3 }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={onClose} variant="text">{t('cancel')}</Button>
          <Button onClick={handleSave} variant="contained" disabled={!password}>{t('save')}</Button>
        </Box>
      </Box>
    </Modal>
  );
}
